module.exports = __webpack_public_path__ + "static/media/hushdream-2.4db6afe6.jpg";